export default "__VITE_ASSET__309842c3__"